export enum ScreenSize {
	XS = 480, // Extra small screen / phone
	SM = 768, // Small screen / tablet
	MD = 992, // Medium screen / desktop
	LG = 1400 // Large screen / wide desktop
}